<script lang="ts" setup>
  import AppBreadcrumbs from '@/layouts/blocks/AppBreadcrumbs.vue'
  import ActivityFeed from '@/components/activity-feed/ActivityFeed.vue'
  import { RouterView, useRouter } from 'vue-router'
  import AnchorDefault from '@/elements/AnchorDefault.vue'
  import { Router } from '@/helpers/router'
  import { useToast } from 'primevue/usetoast'
  import type { ToastMessageOptions } from 'primevue/toast'
  import { useLogger } from '@/composables/useLogger.ts'
  import { useTitrop } from '@/composables/useTitrop.ts'
  import { useAuthStore } from '@/stores'

  const logger = useLogger('ContentWrapper')
  const toast = useToast()
  const routeRefreshKey = ref(0)
  // onErrorCaptured((err: Error, instance: ComponentPublicInstance | null): void => {
  //     isLoading.value = false
  //     logger.error(err)
  //     error.value = {
  //         error: err,
  //         instance: instance
  //     }
  //     ErrorService.Set(err, instance)
  //     // return false
  // })

  const titrop = useTitrop()
  const devMeta = ref<{ currComp?: string; compFn?: string; compOie?: string; compDebug: () => void }>()
  if (titrop.value.DEV) {
    devMeta.value = {
      currComp: undefined,
      compFn: undefined,
      compOie: undefined,
      compDebug: () => {
        /*NoOp*/
      }
    }
    if (import.meta.hot) {
      const router = useRouter()

      const refreshDevMeta = () => {
        if (!devMeta.value) devMeta.value = {} as typeof devMeta.value
        const currComp = Router.currentRoute.value.matched[Router.currentRoute.value.matched.length - 1]?.components?.default
        if (currComp && '__file' in currComp) devMeta.value.compFn = currComp.__file
        if (devMeta.value.compFn) devMeta.value.compOie = `${import.meta.env.BASE_URL}/__open-in-editor?file=${devMeta.value.compFn}`

        devMeta.value.compDebug = () => {
          if (!devMeta.value) return
          const opener = window.open(devMeta.value.compOie, '_blank', 'popup=true,width=1,height=1')
          setTimeout(() => opener?.close(), 250)
        }
      }
      let hmrStartMsg: ToastMessageOptions | undefined = undefined
      // https://vitejs.dev/guide/api-hmr#hot-on-event-cb
      import.meta.hot.on('vite:beforeUpdate', () => {
        hotreloading.value = true
        toast.add(
          (hmrStartMsg = {
            severity: 'info',
            summary: 'Hot reloading',
            life: 1000
          })
        )

        refreshDevMeta()
      })

      import.meta.hot.on('vite:afterUpdate', () => {
        useAuthStore()
          .refreshWhoAmI()
          .then(() => {
            if (hmrStartMsg) toast.remove(hmrStartMsg)
            toast.add({
              severity: 'info',
              summary: 'Hot reloaded',
              life: 1000
            })

            refreshDevMeta()
            hotreloading.value = false
          })
      })
      import.meta.hot.on('vite:invalidate', () => {
        // void useAuthStore().refreshWhoAmI()
      })
      watch(router.currentRoute, refreshDevMeta)
      refreshDevMeta()
    }
  }
  const hotreloading = ref(false)


  function refreshCurrentRouteView() {
    routeRefreshKey.value += 1
  }

  const routerViewKey = computed(() => `${Router.currentRoute.value.fullPath}-${routeRefreshKey.value}`)

  useEventBus('same_route_click').on(() => {
    refreshCurrentRouteView()
  })
</script>

<template>
  <main
    id="main-content"
    :key="$route.fullPath"
    class="w-full max-w-full">
    <AppBreadcrumbs />
    <div class="md:pr-17 md:flex-auto md:pt-0 md:px-4">
      <div>
        <div
          v-if="devMeta && $titrop.showViewComponents && !hotreloading"
          :key="$route.fullPath">
          <AnchorDefault
            :key="$route.fullPath"
            @click="devMeta.compDebug">
            {{ devMeta.compFn }}
          </AnchorDefault>
        </div>
        <div v-if="$route.meta?.markAsReviewRequired">
          <Message severity="info">Diese View benötigt noch Nach- bzw. Überarbeitung!</Message>
          <RouterView :key="routerViewKey" />
        </div>
        <RouterView v-else :key="routerViewKey" />
      </div>
    </div>
  </main>
  <KeepAlive>
    <ActivityFeed
      v-if="$titrop.config.app('enable_activity_feed', false).value"
      class="min-w-max md:w-fit md:pt-0 z-0 bg-white dark:bg-current" />
  </KeepAlive>
</template>

<style scoped></style>
